module.exports = __webpack_public_path__ + "img/yuqing.ab0078d7.svg";